var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGn = function SvgIconGn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M16.174.746A12 12 0 0 0 12 0c-1.467 0-2.874.264-4.174.746L7.305 12l.521 11.254c1.3.482 2.707.746 4.174.746s2.874-.264 4.174-.746L16.696 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 12c0 5.16 3.257 9.558 7.826 11.254V.747C3.256 2.442 0 6.84 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M24 12c0-5.16-3.257-9.558-7.826-11.253v22.507C20.744 21.558 24 17.16 24 12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconGn;